import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const EPDependentsItem = ({
  children,
  linkDisabled,
  link
}) => {
  if (linkDisabled || !link) return /*#__PURE__*/_jsx("span", {
    children: children
  });
  return /*#__PURE__*/_jsx(Link, {
    external: true,
    href: link,
    children: children
  });
};
export default EPDependentsItem;